import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize20 {
  size?: '20';
}
interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize20 | OverrideIconSize24;

const SvgComponent = ({
  size = '20',
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '20') {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.64644 2.14645C9.84171 1.95118 10.1583 1.95118 10.3535 2.14645L13.182 4.97487C13.3772 5.17014 13.3772 5.48672 13.182 5.68198C12.9867 5.87724 12.6701 5.87724 12.4749 5.68198L10.5 3.70711V12.5C10.5 12.7761 10.2761 13 10 13C9.72386 13 9.5 12.7761 9.5 12.5V3.7071L7.52512 5.68198C7.32986 5.87724 7.01328 5.87724 6.81802 5.68198C6.62275 5.48672 6.62275 5.17014 6.81802 4.97487L9.64644 2.14645ZM4 10.5C4 10.2239 4.22386 10 4.5 10H7C7.27614 10 7.5 9.77614 7.5 9.5C7.5 9.22386 7.27614 9 7 9H4.5C3.67157 9 3 9.67157 3 10.5V15.5C3 16.3284 3.67157 17 4.5 17H15.5C16.3284 17 17 16.3284 17 15.5V10.5C17 9.67157 16.3284 9 15.5 9H13C12.7239 9 12.5 9.22386 12.5 9.5C12.5 9.77614 12.7239 10 13 10H15.5C15.7761 10 16 10.2239 16 10.5V15.5C16 15.7761 15.7761 16 15.5 16H4.5C4.22386 16 4 15.7761 4 15.5V10.5Z"
          fill={color}
        />
      </svg>
    );
  }
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.4994 4.705L12.5 15.5012C12.5 15.7774 12.2761 16.0012 12 16.0012C11.7239 16.0012 11.5 15.7774 11.5 15.5012L11.4994 4.705L8.11091 8.09619L8.04167 8.15405C7.8468 8.28905 7.57737 8.26976 7.40381 8.09619C7.20854 7.90093 7.20854 7.58435 7.40381 7.38909L11.6779 3.11759L11.733 3.07719L11.8279 3.03041L11.8946 3.01113C11.9286 3.00384 11.9638 3 12 3L12.0742 3.00547L12.1277 3.01651L12.1943 3.03917L12.2707 3.07951C12.3001 3.09844 12.3279 3.12075 12.3536 3.14645L16.5962 7.38909L16.654 7.45833C16.789 7.6532 16.7698 7.92263 16.5962 8.09619L16.5269 8.15405C16.3321 8.28905 16.0627 8.26976 15.8891 8.09619L12.4994 4.705ZM9 11.5C9 11.2239 8.77614 11 8.5 11H5.5L5.35554 11.0069C4.59489 11.0796 4 11.7203 4 12.5V18.5L4.00687 18.6445C4.07955 19.4051 4.7203 20 5.5 20H18.5L18.6445 19.9931C19.4051 19.9204 20 19.2797 20 18.5V12.5L19.9931 12.3555C19.9204 11.5949 19.2797 11 18.5 11H15.5L15.4101 11.0081C15.1769 11.0504 15 11.2545 15 11.5C15 11.7761 15.2239 12 15.5 12H18.5L18.5899 12.0081C18.8231 12.0504 19 12.2545 19 12.5V18.5L18.9919 18.5899C18.9496 18.8231 18.7455 19 18.5 19H5.5L5.41012 18.9919C5.17688 18.9496 5 18.7455 5 18.5V12.5L5.00806 12.4101C5.05039 12.1769 5.25454 12 5.5 12H8.5L8.58988 11.9919C8.82312 11.9496 9 11.7455 9 11.5Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 20, 24 입니다.
 *
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'share');
export default IconComponent;
